import { createModalHook } from '@change-corgi/design-system-legacy/modals';

import { EmbeddedVideo } from 'src/app/shared/components/embeddedMedia';

import { useGetEmbedUrl } from '../useGetEmbedUrl';

export const useOpenVideoModal = createModalHook({
	name: 'ImpactOpenVideoModal',
	body: function SharePetitionModal() {
		const {
			data: { embedHtml },
		} = useGetEmbedUrl();
		return <EmbeddedVideo mt={24} aspectRatio="16/9" embedHtml={embedHtml}></EmbeddedVideo>;
	},
	stylesOverrides: {
		width: ['calc(100vw - 10px)', 920],
	},
});
